// extracted by mini-css-extract-plugin
export default {"defaultBullet":"Link_defaultBullet__yniuf","image":"Link_image__zNiv3","textContainer":"Link_textContainer__uEbJ6"};